// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 公共样式的统一引入
import '@/common/stylus/index.styl'
import Print from 'vue-print-nb'
//导入vcharts
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
import locale from 'element-ui/lib/locale/lang/en'

// import fontSize from'./common/utils/font'
Vue.use(ElementUI, { locale })

Vue.use(dataV)
Vue.use(Print)
Vue.use(ElementUI)
Vue.config.productionTip = false
// Vue.prototype.$fontSize=fontSize;
// ...
import Request from './common/utils/request' // 引入封装的文件
const { request } = Request
Vue.prototype.$request = request // 挂载到全局上
// ...
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js